import React, { useState } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import Detail from './Detail';
import Sticky from 'react-stickynode';
import Summary from './Summary';
import classnames from 'classnames';
import { component } from './styles.module.scss';

const atlas = new AtlasMetadataClient();

const CountryRow = (props) => {
  const [showDetail, setShowDetail] = useState(false);

  const country = atlas.getCountry(props.isoAlpha2);

  return (
    <div
      id={`priority-groups-for-${country.slug}`}
      className={classnames(component)}
    >
      <Sticky
        enabled={showDetail}
        top={75}
        bottomBoundary={`#priority-groups-for-${country.slug}`}
      >
        <Summary {...props} showDetail={showDetail} setShowDetail={setShowDetail} />
      </Sticky>
      <Detail
        showDetail={showDetail}
        country={country}
        priorityGroups={props.priorityGroups}
      />
    </div>
  );
};

export default CountryRow;
